import { useState, useEffect } from 'react';

const useOfflineStatus = () => {
  const [isOffline, setIsOffline] = useState<boolean>(!(navigator && navigator.onLine));

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOffline(false);
    };

    const updateOfflineStatus = () => {
      setIsOffline(true);
    };
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOfflineStatus);
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOfflineStatus);
    };
  }, []);

  return isOffline;
};

export default useOfflineStatus;
